export const HYBRID_AUTH_PATH = 'auth';
export const HYBRID_REGISTER_PATH = 'register';
